<script setup>
// 3rd.
import { computed, onMounted, ref, watchEffect } from 'vue';
import { storeToRefs } from 'pinia';
import TrioAssets from 'trio-assets-js';
// Utils.
import calculateHeight from '../js/utils/calculateHeight';
import isMobile from '../js/utils/isMobile';
// Store.
import useVideosStore from '../js/stores/videos';

// Props.
const props = defineProps({
  background: {
    type: String,
    required: true,
  },
  direction: {
    type: String,
    default: 'ttb', // see trio-assets-js
  },
  videoData: {
    type: Object,
    required: false,
    default: () => {},
  },
});

// Data.
const { isPlaying } = storeToRefs(useVideosStore());
const video = ref(null);

// Computed.
const isVideo = computed(() => !!Object.keys(props.videoData).length);

// Methods.
const calculateParallaxHeights = () => {
  // Todo: these calculation are probably not needed now that we have CSS variables.
  // Parallax has 100vh - header.height on project detail pages
  const projectDetailParallax = document.querySelector('.parallax--dark');
  if (projectDetailParallax) {
    calculateHeight(projectDetailParallax);
  }

  // Decrease jitter on mobile devices when viewport changes (those god damn browser toolbars.. )
  const frontpageMain = document.querySelector('.section--main');
  if (frontpageMain) {
    frontpageMain.style.height = `${window.innerHeight}px`;
  }
};

// Mounted.
onMounted(() => {
  calculateParallaxHeights();

  // Activate parallax effect only on desktop.
  if (!isMobile()) {
    TrioAssets.parallax();
  }
});

// Pause and play the autoplay depending on other videos playing.
watchEffect(() => {
  if (isPlaying.value) {
    video.value?.pause();
  } else {
    video.value?.play();
  }
});
</script>

<template>
  <section
    class="parallax js-parallax"
    :class="{ 'parallax--video': isVideo }"
    data-mode="background"
    data-y="-100, 150"
    :data-auto="direction"
    :style="[isVideo ? null : { backgroundImage: `url('${background}')` }]">
    <slot></slot>
    <video
      data-mode="element"
      data-unit="px"
      data-relative-viewport="false"
      data-y="-100, 200"
      ref="video"
      v-if="isVideo"
      autoplay
      muted
      loop
      playsInline
      class="js-parallax parallax__video">
      <source :src="videoData.src" :type="videoData.type" />
    </video>
  </section>
</template>
